

<div class="top-nav-container mat-toolbar mat-primary mat-elevation-z2">

  <!-- Logo -->
  <div class="top-nav-left">
    <!-- Logo -->
    <div role="img" aria-label="logo" class="fg-logo-container d-inline-block"></div>

    <!-- Breadcrumb -->
    <div class="nav-breadcrumb">
      @if (apps) {
        <fg-mega-menu   [myapps]="apps"  (menuItemSelected)="onMenuItemSelected($event)"  ></fg-mega-menu>
      }
      <span class="breadcrumb-app">{{ getAppName() || currentApp }} </span>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-menu">{{ getMenuName() || currentPage }} </span>
    </div>
  </div>
  <!-- Menu Items -->

  <!-- Icons + CTA -->
  <div class="nav-actions">
    <a  type="link" aria-label="Home" mat-icon-button href="/launcher">
      <mat-icon aria-label="Home icon">home</mat-icon>
    </a>
    <!-- <div class="launcher">
    <fg-app-launcher class="launcher"></fg-app-launcher>
  </div> -->

  <button  mat-icon-button  [matMenuTriggerFor]="languageMenu"
    matTooltipPosition="below">
    <mat-icon >language</mat-icon>

  </button>
  <mat-menu #languageMenu="matMenu" class="fg-more-toolbar-panel" backdropClass="fg-more-toolbar-menu"
    xPosition="before">
    <button mat-menu-item (click)="changeLanguage('en')">
      <span>🇬🇧 English</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('ta')">
      <span>அ Tamil</span>
    </button>
    <button mat-menu-item (click)="changeLanguage('ar')">
      <span>؈ Arabic</span>
    </button>
  </mat-menu>
  <button mat-icon-button (click)="triggerSettingsDrawer()" aria-label="Settings">
    <mat-icon>manage_accounts</mat-icon>
  </button>

</div>
</div>


